import { useEffect, useState } from "react";
import { Container, FormLabel, Button, Modal, Row, Col, FormControl } from "react-bootstrap";
import { dtFormatter, dtForInputDate } from "./AuxiliaryFunctions";
import ItemDataService from './services/item.service'

function KitchenQuoteJobInterview(props) { 
  const [lgShow, setLgShow] = useState(false);
  /*
  const [jobname, setJobname] = useState("");
  const [jobaddress, setJobaddress] = useState("");
  const [duedate, setDuedate] = useState("");
  */
  /*
  const [finishcabinets, setFinishCabinets] = useState([]);
  const [finishcabinetdoors, setFinishCabinetdoors] = useState([]);

  const [finishcabinet, setFinishCabinet] = useState({});  
  const [finishcabinetdoor, setFinishCabinetDoor] = useState({});    
  */
  const jobname = props.jobname;
  const jobaddress = props.jobaddress;
  const duedate = props.duedate;
  const finishcabinets = props.finishcabinets;
  const finishcabinetdoors = props.finishcabinetdoors;
  const finishcabinet = props.finishcabinet;
  const finishcabinetdoor = props.finishcabinetdoor;
  const defaultbackfinish = props.defaultbackfinish;
  const [originalvals, setOriginalvals] = useState(true);
  //const defaultbackfinish = props.finishcabinets.find(fincab => fincab.id === props.finishcabinet)?.defaultbackfinish || "";

  /*
  const onChangeJobname = (e) => {
    setJobname(e.target.value);
  }

  const onChangeJobaddress = (e) => {
    setJobaddress(e.target.value);
  }
  
  const onChangeDuedate = (e) => {
    setDuedate(new Date(dtFormatter(e.target.valueAsNumber,3)).valueOf());
  }  
  */
  /*
  const onChangeFinishCabinet = (e) => {
    let finishcabinetId = parseInt(e.target.value);
    setFinishCabinet(finishcabinets.find(obj => obj.id === finishcabinetId) || {});   
  }  

  const onChangeFinishCabinetDoor = (e) => {
    let finishcabinetdoorId = parseInt(e.target.value);
    setFinishCabinetDoor(finishcabinetdoors.find(obj => obj.id === finishcabinetdoorId) || {});   
  }   
  */    
  /*
  const retrieveFinishCabinets = () => {
    ItemDataService.getItemByCategory({"itemcategory":"finish_cabinet_box_case", "itemcategoryval":1},"id","ASC")
    .then(response => {
      setFinishCabinets(response.data);
    })
    .catch(e => {
      console.log(e);
    });    
  } 
  
  const retrieveFinishCabinetDoors = () => {
    ItemDataService.getItemByCategory({"itemcategory":"finish_cabinet_door", "itemcategoryval":1},"id","ASC")
    .then(response => {
      setFinishCabinetdoors(response.data);
    })
    .catch(e => {
      console.log(e);
    }); 
  }     
  */
  // This is how you make the current user available on any functional component
  //const { user } = useSelector(state => state.auth);

  const handleClose = () => setLgShow(false);

  const handleShow = () => {
    props.retrieveVersionDataForJobInterview(originalvals);
    //props.finishcabinets.find(fincab => fincab.id === props.finishcabinet);
    setLgShow(true); 
    setOriginalvals(false);
  }

  useEffect(() => {
    props.retrieveFinishCabinets();
    props.retrieveFinishCabinetDoors();
  },[]);

  return (
    <>      
      <Button onClick={handleShow} className='ms-2' lg={4} style={{maxWidth:"200px",maxHeight:'38px'}} variant="primary">{"Interview"}</Button>          
      <Modal
        size="xl"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            {'Job Interview'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row className='mt-2' >
              <Col className='col-md-3' sm={8}>
                <FormLabel htmlFor="jobname">Job Name:</FormLabel>
                <FormControl className="form-control"
                  defaultValue={jobname}
                  onChange={props.onChangeJobName}
                  type="text"
                  name="jobname"
                  id="jobname" />
              </Col>
              <Col className='col-md-3' sm={8}>
                <FormLabel htmlFor="jobaddress">Job Address:</FormLabel>
                <FormControl className="form-control"
                  defaultValue={jobaddress}
                  onChange={props.onChangeJobAddress}              
                  type="text"
                  name="jobaddress"
                  id="jobaddress" />
              </Col>  

              <Col className='col-md-3' sm={8}>
                <FormLabel htmlFor="duedate">Due Date:</FormLabel>
                <FormControl className="form-control"
                  onChange={props.onChangeDueDate}                
                  type="date"
                  name="duedate"
                  data-date="" 
                  data-date-format="DD-MM-YYYY"
                  value={dtForInputDate(props.duedate)}                
                  id="duedate" />
              </Col>                      
            </Row>

            <Row className='mt-2' >
              <Col className='col-md-3' sm={8}>
                <FormLabel>Select finish for the cabinet box case:</FormLabel>
                <div style={{display:"flex"}}>
                <select onChange={props.onChangeFinishCabinet} className="form-control" id="finishcabinet" name="finishcabinet">
                  <ListOfFinishCabinet finishcabinets={finishcabinets} defaultValue={finishcabinet}/>       
                </select>
                </div>
                <FormLabel className='mt-2 form-control-sm'>Select your finish from the list above.</FormLabel>
              </Col>
              <Col className='col-md-3' sm={8}>
                <FormLabel className='mt-2'>Auto selection back finish:</FormLabel>
                <FormControl type="text" name="backfinish" id="backfinish" disabled 
                  value={props.defaultbackfinish}
                />
                <FormLabel className='mt-2 form-control-sm'>Match back finish to box finish.</FormLabel>              
              </Col>

              <Col className='col-md-3' sm={8}>
                <FormLabel>Select finish for the cabinet door:</FormLabel>
                <div style={{display:"flex"}}>
                <select onChange={props.onChangeFinishCabinetDoor} className="form-control" id="finishcabinetdoor" name="finishcabinetdoor">
                  <ListOfFinishCabinetDoor finishcabinetdoors={finishcabinetdoors} defaultValue={props.finishcabinetdoor}/>       
                </select>
                </div>
                <FormLabel className='mt-2 form-control-sm'>Match back finish to box finish.</FormLabel>              
              </Col>

                   
            </Row>


          </Container>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={handleClose}>Save</Button>
        </Modal.Footer>

      </Modal>
      
    </>
  )
}

const ListOfFinishCabinet = (props) => {
  if (!props.finishcabinets) {
    return 
  }
  const rows = props.finishcabinets.map((row, index) => {
    return (  
      <option key={index} value={row.id} selected={props.defaultValue == row.id}>        
        {row.itemdescription}
      </option>
    )
  })  
  return (      
    <>        
    <option disabled selected={props.defaultValue == null}>
      {"Select"}
    </option>
    {rows}
    </>
  )
}

const ListOfFinishCabinetDoor = (props) => {
  if (!props.finishcabinetdoors) {
    return 
  }
  const rows = props.finishcabinetdoors.map((row, index) => {
    return (  
      <option key={index} value={row.id} selected={props.defaultValue == row.id}>        
        {row.itemdescription}
      </option>
    )
  })  
  return (      
    <>        
    <option disabled selected={props.defaultValue === null}>
      {"Select"}
    </option>
    {rows}
    </>
  )
}

export default KitchenQuoteJobInterview;